<div class="container" style="width: 97%; margin-top: 1rem">
  <div
    class="row"
    style="margin-bottom: auto; margin-left: auto; margin-right: auto"
  >
    <div class="col-lg-12" style="padding-left: 0px; padding-right: 0px">
      <div
        class="panel panel-primary"
        style="background: #fff; box-shadow: 4px 4px 4px #888888"
      >
        <div class="panel-heading">
          <h4 style="margin-bottom: 3px; margin-top: 5px">Add Building</h4>
        </div>

        <div class="panel-body">
          <form [formGroup]="formBuildingDetails" novalidate>
            <mat-expansion-panel
              class="md-expansion-demo-width"
              #buildingDetailsPanel
              expanded="true"
            >
              <mat-expansion-panel-header>
                <mat-panel-title><h6>Add Building</h6></mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label class="label-input pull-right"
                      >{{ 'selectSite' | translate
                      }}<span class="iep-required">*</span></mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <mat-label>{{
                        'pleaseSelectSite' | translate
                      }}</mat-label>
                      <mat-select
                        [(ngModel)]="siteId"
                        ngDefaultControl
                        formControlName="siteNameCtr"
                        (ngModelChange)="onSiteChange()"
                        required
                      >
                        <mat-option
                          *ngFor="let item of sites"
                          [value]="item.SiteId"
                          >{{ item.SiteName }}</mat-option
                        >
                      </mat-select>
                      <mat-error
                        *ngIf="isFieldHasError('siteNameCtr', 'required')"
                        >{{ 'pleaseSelectSite' | translate }}</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label class="label-input pull-right"
                      >Enter Building<span class="iep-required"
                        >*</span
                      ></mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <input
                        matInput
                        ngDefaultControl
                        formControlName="building"
                        placeholder="Enter Building Name"
                        required
                      />
                      <mat-error *ngIf="isFieldHasError('building', 'required')"
                        >This field is required.</mat-error
                      >
                      <mat-error
                        *ngIf="isFieldHasError('building', 'maxlength')"
                      >
                        Please provide name up to 50 Characters.
                      </mat-error>
                      <mat-error *ngIf="isFieldHasError('building', 'pattern')">
                        Only (& . - _ / : ,) special symbol allowed.
                      </mat-error>
                      <mat-error
                        *ngIf="isFieldHasError('building', 'whitespace')"
                        >Please enter valid text.</mat-error
                      >
                      <mat-error
                        *ngIf="isFieldHasError('building', 'duplicated')"
                        >{{ formBuildingDetails.get('building').value }} already
                        exist
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row text-center">
                <div class="col-12">
                  <button
                    type="button"
                    id="addBuildingbtn"
                    class="btn mat-raised-button addBuildingbtn"
                    (click)="addBuilding()"
                    [disabled]="!formBuildingDetails.get('building').valid"
                  >
                    Add
                  </button>
                </div>
              </div>
              <br />
              <div class="row">
                <div
                  class="col-lg-6"
                  *ngIf="buildingList && buildingList.length"
                >
                  <div class="table-responsive">
                    <table class="table">
                      <caption>
                        Building list
                      </caption>
                      <tr class="row-sticky">
                        <th class="width100 text-center" scope="col">Sl No.</th>
                        <th scope="col">Building Name</th>
                      </tr>
                      <tr *ngFor="let item of buildingList; let i = index">
                        <td class="width100 text-center">{{ i + 1 }}</td>
                        <td>{{ item }}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          </form>

          <br />

          <mat-expansion-panel
            class="md-expansion-demo-width"
            #buildingDetailsPanel
            expanded="true"
          >
            <mat-expansion-panel-header>
              <mat-panel-title><h6>Map Loads to Building</h6></mat-panel-title>
            </mat-expansion-panel-header>
            <form [formGroup]="formLinkLoad" novalidate>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                  <div class="col-md-4">
                    <mat-label class="label-input"
                      >Building<span class="iep-required">*</span></mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <mat-label>Please Select Building</mat-label>
                      <mat-select
                        formControlName="building"
                        ngDefaultControl
                        required
                      >
                        <mat-option>Select Building</mat-option>
                        <mat-option
                          *ngFor="let item of buildingList"
                          [value]="item"
                        >
                          {{ item }}</mat-option
                        >
                      </mat-select>
                      <mat-error *ngIf="hasError('building', 'required')"
                        >Please Select Building</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                  <div class="col-md-4">
                    <mat-label class="label-input"
                      >Load<span class="iep-required">*</span></mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <mat-label>Please Select Load</mat-label>
                      <mat-select
                        formControlName="loadId"
                        required
                        ngDefaultControl
                        #loadSelect
                        [compareWith]="compareFnLoad"
                      >
                        <mat-option>
                          <ngx-mat-select-search
                            (change)="changeLoadFilter($event)"
                            ngDefaultControl
                            formControlName="loadSearchCtr"
                            [placeholderLabel]="'Select Load'"
                          >
                          </ngx-mat-select-search>
                        </mat-option>

                        <mat-option
                          *ngFor="let load of filteredLoads | async"
                          [value]="load"
                        >
                          {{ load.name }}</mat-option
                        >
                      </mat-select>
                      <mat-error *ngIf="hasError('loadId', 'required')"
                        >Please Select Load</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div
                  class="col-xs-12 col-sm-12 col-md-6 col-lg-6"
                  *ngIf="sensors && sensors.type === 'GenericSensorLoad'"
                >
                  <div class="col-md-4">
                    <mat-label class="label-input"
                      >Sensor<span class="iep-required">*</span></mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <mat-label>Please Select Sensor</mat-label>
                      <mat-select formControlName="flowChannelID">
                        <mat-option>Select Sensor</mat-option>
                        <mat-option
                          *ngFor="let param of sensors?.paramArr"
                          [value]="param"
                        >
                          {{ param.name ? param.name : param }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="hasError('flowChannelID', 'required')"
                        >Please Select Sensor</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row text-center">
                <div class="col-12">
                  <button
                    type="button"
                    id="loadsbtn"
                    class="btn mat-raised-button addBuildingbtn"
                    (click)="saveLinkingBuildingToLoad()"
                    [disabled]="!formLinkLoad.valid"
                  >
                    Add
                  </button>
                  &nbsp;
                  <button
                    type="button"
                    id="addUtilitybtn"
                    class="btn mat-raised-button addBuildingbtn"
                    (click)="clearLinkLoadForm()"
                    [disabled]="!formLinkLoad.valid"
                  >
                    Clear
                  </button>
                </div>
              </div>
              <br />
              <div class="row">
                <div
                  class="col-lg-9"
                  *ngIf="loadsDetails && loadsDetails.length"
                >
                  <div class="table-responsive">
                    <table class="table">
                      <caption>
                        Load for Building
                      </caption>
                      <tr class="row-sticky">
                        <th class="width100 text-center" scope="col">Sl No.</th>
                        <th scope="col">Building Name</th>
                        <th scope="col">Load</th>
                      </tr>
                      <tr *ngFor="let item of loadsDetails; let i = index">
                        <td class="width100 text-center">{{ i + 1 }}</td>
                        <td class="column-content">
                          <span
                            *ngFor="let building of item.buildings"
                            class="border-bottom"
                            >{{ building.buildingName }}
                          </span>
                        </td>
                        <td class="column-content">
                          <div
                            *ngFor="let building of item.buildings"
                            class="border-bottom"
                          >
                            <div
                              *ngIf="
                                building &&
                                building.loads &&
                                building.loads.length
                              "
                            >
                              <span *ngFor="let load of building.loads"
                                >{{ load.name }} <br
                              /></span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </form>
          </mat-expansion-panel>
        </div>
      </div>
    </div>
  </div>
</div>
